import { Box } from '@mui/material';

import { FProgressBar } from '../../../components/base';
import PageContainer from '../../../components/layout/PageContainer';
import NavBar from '../../../components/layout/treatment-plan/NavBar';
import StatusBar from '../../../components/layout/treatment-plan/statusBar';
import TreatmentPlanLegacyRoutes from '../TreatmentPlanLegacyRoutes';
import { useTreatmentPlanLegacyLoading } from '../hooks';
import { TREATMENT_PLAN_PAGE_CONTAINER_SX } from '../styles';

export default function TreatmentPlanLegacy() {
  const isLoading = useTreatmentPlanLegacyLoading();

  return (
    <PageContainer sx={TREATMENT_PLAN_PAGE_CONTAINER_SX}>
      {isLoading && <FProgressBar />}
      <StatusBar />
      <NavBar />
      <Box sx={{ mt: 5 }}>
        <TreatmentPlanLegacyRoutes />
      </Box>
    </PageContainer>
  );
}
